[
  {
    "kind": "INTERFACE",
    "name": "User",
    "possibleTypes": [
      {
        "name": "AppUser"
      },
      {
        "name": "AtlassianAccountUser"
      },
      {
        "name": "CustomerUser"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "AppDeploymentEvent",
    "possibleTypes": [
      {
        "name": "AppDeploymentLogEvent"
      },
      {
        "name": "AppDeploymentSnapshotLogEvent"
      },
      {
        "name": "AppDeploymentTransitionEvent"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MarketplaceAppDeployment",
    "possibleTypes": [
      {
        "name": "MarketplaceCloudAppDeployment"
      },
      {
        "name": "MarketplaceConnectAppDeployment"
      },
      {
        "name": "MarketplaceInstructionalAppDeployment"
      },
      {
        "name": "MarketplacePlugins1AppDeployment"
      },
      {
        "name": "MarketplacePlugins2AppDeployment"
      },
      {
        "name": "MarketplaceWorkflowAppDeployment"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CompatibleAtlassianProduct",
    "possibleTypes": [
      {
        "name": "CompatibleAtlassianCloudProduct"
      },
      {
        "name": "CompatibleAtlassianDataCenterProduct"
      },
      {
        "name": "CompatibleAtlassianServerProduct"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceEntitlementInfo",
    "possibleTypes": [
      {
        "name": "CommerceEntitlementInfoCcp"
      },
      {
        "name": "CommerceEntitlementInfoHams"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceEntitlement",
    "possibleTypes": [
      {
        "name": "CcpEntitlement"
      },
      {
        "name": "HamsEntitlement"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceOffering",
    "possibleTypes": [
      {
        "name": "CcpOffering"
      },
      {
        "name": "HamsOffering"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceChargeElement",
    "possibleTypes": [
      {
        "name": "CcpChargeElement"
      },
      {
        "name": "HamsChargeElement"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceOfferingTrial",
    "possibleTypes": [
      {
        "name": "CcpOfferingTrial"
      },
      {
        "name": "HamsOfferingTrial"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceEntitlementPreDunning",
    "possibleTypes": [
      {
        "name": "CcpEntitlementPreDunning"
      },
      {
        "name": "HamsEntitlementPreDunning"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceEntitlementRelationship",
    "possibleTypes": [
      {
        "name": "CcpEntitlementRelationship"
      },
      {
        "name": "HamsEntitlementRelationship"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceSubscription",
    "possibleTypes": [
      {
        "name": "CcpSubscription"
      },
      {
        "name": "HamsSubscription"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceAccountDetails",
    "possibleTypes": [
      {
        "name": "CcpAccountDetails"
      },
      {
        "name": "HamsAccountDetails"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceInvoiceGroup",
    "possibleTypes": [
      {
        "name": "CcpInvoiceGroup"
      },
      {
        "name": "HamsInvoiceGroup"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceInvoiceGroupExperienceCapabilities",
    "possibleTypes": [
      {
        "name": "CcpInvoiceGroupExperienceCapabilities"
      },
      {
        "name": "HamsInvoiceGroupExperienceCapabilities"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceExperienceCapability",
    "possibleTypes": [
      {
        "name": "CcpAddPaymentMethodExperienceCapability"
      },
      {
        "name": "CcpApplyEntitlementPromotionExperienceCapability"
      },
      {
        "name": "CcpCancelEntitlementExperienceCapability"
      },
      {
        "name": "CcpChangeOfferingExperienceCapability"
      },
      {
        "name": "CcpCompareOfferingsExperienceCapability"
      },
      {
        "name": "CcpConfigurePaymentMethodExperienceCapability"
      },
      {
        "name": "CcpCreateEntitlementExperienceCapability"
      },
      {
        "name": "CcpExperienceCapability"
      },
      {
        "name": "CcpManageEntitlementExperienceCapability"
      },
      {
        "name": "CcpMultipleProductUpgradesExperienceCapability"
      },
      {
        "name": "CcpPlaceOrderLiteExperienceCapability"
      },
      {
        "name": "HamsAddPaymentMethodExperienceCapability"
      },
      {
        "name": "HamsChangeOfferingExperienceCapability"
      },
      {
        "name": "HamsConfigurePaymentMethodExperienceCapability"
      },
      {
        "name": "HamsExperienceCapability"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceChargeDetails",
    "possibleTypes": [
      {
        "name": "CcpChargeDetails"
      },
      {
        "name": "HamsChargeDetails"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceChargeQuantity",
    "possibleTypes": [
      {
        "name": "CcpChargeQuantity"
      },
      {
        "name": "HamsChargeQuantity"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommercePricingPlan",
    "possibleTypes": [
      {
        "name": "CcpPricingPlan"
      },
      {
        "name": "HamsPricingPlan"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommercePrimaryCycle",
    "possibleTypes": [
      {
        "name": "CcpCycle"
      },
      {
        "name": "HamsPrimaryCycle"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceTrial",
    "possibleTypes": [
      {
        "name": "CcpTrial"
      },
      {
        "name": "HamsTrial"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceTransactionAccount",
    "possibleTypes": [
      {
        "name": "CcpTransactionAccount"
      },
      {
        "name": "HamsTransactionAccount"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceTransactionAccountExperienceCapabilities",
    "possibleTypes": [
      {
        "name": "CcpTransactionAccountExperienceCapabilities"
      },
      {
        "name": "HamsTransactionAccountExperienceCapabilities"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommerceEntitlementExperienceCapabilities",
    "possibleTypes": [
      {
        "name": "CcpEntitlementExperienceCapabilities"
      },
      {
        "name": "HamsEntitlementExperienceCapabilities"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceComment",
    "possibleTypes": [
      {
        "name": "ConfluenceFooterComment"
      },
      {
        "name": "ConfluenceInlineComment"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceCommentContainer",
    "possibleTypes": [
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceAncestor",
    "possibleTypes": [
      {
        "name": "ConfluenceDatabase"
      },
      {
        "name": "ConfluenceEmbed"
      },
      {
        "name": "ConfluenceFolder"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Node",
    "possibleTypes": [
      {
        "name": "ActivitiesEvent"
      },
      {
        "name": "ActivitiesItem"
      },
      {
        "name": "ActivitiesObject"
      },
      {
        "name": "ActivityNode"
      },
      {
        "name": "BitbucketRepository"
      },
      {
        "name": "BitbucketWorkspace"
      },
      {
        "name": "BoardFeatureGroup"
      },
      {
        "name": "BoardScope"
      },
      {
        "name": "CcpCatalogAccount"
      },
      {
        "name": "CcpEntitlement"
      },
      {
        "name": "CcpEntitlementTemplate"
      },
      {
        "name": "CcpInvoiceGroupV2"
      },
      {
        "name": "CcpOffering"
      },
      {
        "name": "CcpOfferingRelationshipTemplate"
      },
      {
        "name": "CcpOrder"
      },
      {
        "name": "CcpPaymentMethod"
      },
      {
        "name": "CcpPricingPlan"
      },
      {
        "name": "CcpProduct"
      },
      {
        "name": "CcpPromotion"
      },
      {
        "name": "CcpQuote"
      },
      {
        "name": "CcpShipToParty"
      },
      {
        "name": "CcpTransactionAccount"
      },
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluenceDatabase"
      },
      {
        "name": "ConfluenceEmbed"
      },
      {
        "name": "ConfluenceFolder"
      },
      {
        "name": "ConfluenceFooterComment"
      },
      {
        "name": "ConfluenceInlineComment"
      },
      {
        "name": "ConfluenceInlineTask"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceSpace"
      },
      {
        "name": "ConfluenceWhiteboard"
      },
      {
        "name": "CustomFilter"
      },
      {
        "name": "DevOpsService"
      },
      {
        "name": "DevOpsServiceAndJiraProjectRelationship"
      },
      {
        "name": "DevOpsServiceAndOpsgenieTeamRelationship"
      },
      {
        "name": "DevOpsServiceAndRepositoryRelationship"
      },
      {
        "name": "DevOpsServiceRelationship"
      },
      {
        "name": "GraphGeneric"
      },
      {
        "name": "GraphIncidentAssociatedPostIncidentReviewLinkRelationship"
      },
      {
        "name": "GraphIncidentHasActionItemRelationship"
      },
      {
        "name": "GraphIncidentLinkedJswIssueRelationship"
      },
      {
        "name": "GraphJiraIssue"
      },
      {
        "name": "GraphJiraProject"
      },
      {
        "name": "GraphJiraVulnerability"
      },
      {
        "name": "GraphProjectService"
      },
      {
        "name": "JiraAnnouncementBanner"
      },
      {
        "name": "JiraAppConfigState"
      },
      {
        "name": "JiraApplicationProperty"
      },
      {
        "name": "JiraBoard"
      },
      {
        "name": "JiraBulkEditField"
      },
      {
        "name": "JiraBulkTransition"
      },
      {
        "name": "JiraBulkTransitionScreenLayout"
      },
      {
        "name": "JiraColorField"
      },
      {
        "name": "JiraConfluenceRemoteIssueLinksField"
      },
      {
        "name": "JiraContext"
      },
      {
        "name": "JiraCrossProjectVersion"
      },
      {
        "name": "JiraDatePickerField"
      },
      {
        "name": "JiraDateTimePickerField"
      },
      {
        "name": "JiraEntityPropertyBoolean"
      },
      {
        "name": "JiraEntityPropertyInt"
      },
      {
        "name": "JiraEntityPropertyJSON"
      },
      {
        "name": "JiraEntityPropertyString"
      },
      {
        "name": "JiraFavouriteValue"
      },
      {
        "name": "JiraFieldScheme"
      },
      {
        "name": "JiraFlagField"
      },
      {
        "name": "JiraFormattingRule"
      },
      {
        "name": "JiraFormulaFieldExpressionConfig"
      },
      {
        "name": "JiraGoal"
      },
      {
        "name": "JiraGoalsField"
      },
      {
        "name": "JiraGroup"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraIssueFieldConfig"
      },
      {
        "name": "JiraIssueLinkField"
      },
      {
        "name": "JiraIssueLinkType"
      },
      {
        "name": "JiraIssueLinkTypeRelation"
      },
      {
        "name": "JiraIssueRestrictionField"
      },
      {
        "name": "JiraIssueSearchView"
      },
      {
        "name": "JiraIssueType"
      },
      {
        "name": "JiraIssueTypeField"
      },
      {
        "name": "JiraJQLHistory"
      },
      {
        "name": "JiraJourneyConfiguration"
      },
      {
        "name": "JiraNavigationUIStateUserProperty"
      },
      {
        "name": "JiraNumberField"
      },
      {
        "name": "JiraOpsgenieTeam"
      },
      {
        "name": "JiraOption"
      },
      {
        "name": "JiraOriginalTimeEstimateField"
      },
      {
        "name": "JiraParentIssueField"
      },
      {
        "name": "JiraParentOption"
      },
      {
        "name": "JiraPlan"
      },
      {
        "name": "JiraPlatformAttachment"
      },
      {
        "name": "JiraPostIncidentReviewLink"
      },
      {
        "name": "JiraPriority"
      },
      {
        "name": "JiraPriorityField"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraProjectCategory"
      },
      {
        "name": "JiraProjectField"
      },
      {
        "name": "JiraProjectTypeDetails"
      },
      {
        "name": "JiraResolution"
      },
      {
        "name": "JiraResolutionField"
      },
      {
        "name": "JiraResourceUsageMetric"
      },
      {
        "name": "JiraRichTextField"
      },
      {
        "name": "JiraRole"
      },
      {
        "name": "JiraScenario"
      },
      {
        "name": "JiraScreen"
      },
      {
        "name": "JiraSecurityLevel"
      },
      {
        "name": "JiraSecurityLevelField"
      },
      {
        "name": "JiraServiceManagementRequestType"
      },
      {
        "name": "JiraSingleLineTextField"
      },
      {
        "name": "JiraSingleSelectUserPickerField"
      },
      {
        "name": "JiraSprint"
      },
      {
        "name": "JiraStatus"
      },
      {
        "name": "JiraStatusCategory"
      },
      {
        "name": "JiraStatusField"
      },
      {
        "name": "JiraSuggestedIssueFieldValue"
      },
      {
        "name": "JiraSystemFilter"
      },
      {
        "name": "JiraTimeTrackingField"
      },
      {
        "name": "JiraTownsquareProjectField"
      },
      {
        "name": "JiraTransition"
      },
      {
        "name": "JiraUserBroadcastMessage"
      },
      {
        "name": "JiraUserNavigationConfiguration"
      },
      {
        "name": "JiraVersion"
      },
      {
        "name": "JiraVersionApprover"
      },
      {
        "name": "JiraVotesField"
      },
      {
        "name": "JiraWatchesField"
      },
      {
        "name": "JiraWorkManagementFormConfiguration"
      },
      {
        "name": "JiraWorkManagementGiraOverview"
      },
      {
        "name": "JiraWorkManagementSavedViewType"
      },
      {
        "name": "JiraWorklog"
      },
      {
        "name": "JswAvailableCardLayoutField"
      },
      {
        "name": "JswCardColor"
      },
      {
        "name": "JswCurrentCardLayoutField"
      },
      {
        "name": "JswCustomSwimlane"
      },
      {
        "name": "JswRegion"
      },
      {
        "name": "JswTimeZone"
      },
      {
        "name": "KnowledgeDiscoveryTopicByAri"
      },
      {
        "name": "OpsgenieTeam"
      },
      {
        "name": "TeamV2"
      },
      {
        "name": "ThirdPartySecurityContainer"
      },
      {
        "name": "ToolchainWorkspace"
      },
      {
        "name": "VirtualAgentIntentTemplate"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ConfluenceInlineTaskContainer",
    "possibleTypes": [
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluencePage"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceLongTaskState",
    "possibleTypes": [
      {
        "name": "ConfluenceLongTaskFailed"
      },
      {
        "name": "ConfluenceLongTaskInProgress"
      },
      {
        "name": "ConfluenceLongTaskSuccess"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Person",
    "possibleTypes": [
      {
        "name": "Anonymous"
      },
      {
        "name": "KnownUser"
      },
      {
        "name": "UnknownUser"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CommentLocation",
    "possibleTypes": [
      {
        "name": "FooterComment"
      },
      {
        "name": "InlineComment"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SearchResult",
    "possibleTypes": [
      {
        "name": "SearchConfluencePageBlogAttachment"
      },
      {
        "name": "SearchConfluenceSpace"
      },
      {
        "name": "SearchDefaultResult"
      },
      {
        "name": "SearchLinkedResult"
      },
      {
        "name": "SearchResultAssetsObject"
      },
      {
        "name": "SearchResultAssetsObjectSchema"
      },
      {
        "name": "SearchResultAssetsObjectType"
      },
      {
        "name": "SearchResultAtlasGoal"
      },
      {
        "name": "SearchResultAtlasGoalUpdate"
      },
      {
        "name": "SearchResultAtlasProject"
      },
      {
        "name": "SearchResultAtlasProjectUpdate"
      },
      {
        "name": "SearchResultAtlasTag"
      },
      {
        "name": "SearchResultBitbucketRepository"
      },
      {
        "name": "SearchResultCompassComponent"
      },
      {
        "name": "SearchResultFederated"
      },
      {
        "name": "SearchResultGoogleDocument"
      },
      {
        "name": "SearchResultGooglePresentation"
      },
      {
        "name": "SearchResultGoogleSpreadsheet"
      },
      {
        "name": "SearchResultGraphDocument"
      },
      {
        "name": "SearchResultJiraBoard"
      },
      {
        "name": "SearchResultJiraDashboard"
      },
      {
        "name": "SearchResultJiraFilter"
      },
      {
        "name": "SearchResultJiraIssue"
      },
      {
        "name": "SearchResultJiraPlan"
      },
      {
        "name": "SearchResultJiraProject"
      },
      {
        "name": "SearchResultMercuryFocusArea"
      },
      {
        "name": "SearchResultMercuryFocusAreaStatusUpdate"
      },
      {
        "name": "SearchResultMicrosoftDocument"
      },
      {
        "name": "SearchResultSlackMessage"
      },
      {
        "name": "SearchResultSpfAsk"
      },
      {
        "name": "SearchResultTalentPosition"
      },
      {
        "name": "SearchResultTrelloBoard"
      },
      {
        "name": "SearchResultTrelloCard"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "SearchLinkedResultEntity",
    "possibleTypes": [
      {
        "name": "ExternalCalendarEvent"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ProductListingResult",
    "possibleTypes": [
      {
        "name": "ProductListing"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CcpBaseLicense",
    "possibleTypes": [
      {
        "name": "CcpDeveloperLicense"
      },
      {
        "name": "CcpLicense"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "CcpDeveloperLicenseResult",
    "possibleTypes": [
      {
        "name": "CcpDeveloperLicense"
      },
      {
        "name": "CcpLicenseError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "CcpLicenseResult",
    "possibleTypes": [
      {
        "name": "CcpLicense"
      },
      {
        "name": "CcpLicenseError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryAutoDefinitionResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryAutoDefinition"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryDefinitionResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryDefinition"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryDefinitionHistoryResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryDefinitionList"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoverySmartAnswersRouteResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoverySmartAnswersRoute"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryBookmarkResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryBookmark"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryAdminhubBookmarksResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryAdminhubBookmarkConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryAdminhubBookmarkResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryAdminhubBookmark"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryTopicResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryTopic"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedTopicHasRelatedEntityUnion",
    "possibleTypes": [
      {
        "name": "AppUser"
      },
      {
        "name": "AtlassianAccountUser"
      },
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "CustomerUser"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "HasPageInfo",
    "possibleTypes": [
      {
        "name": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection"
      },
      {
        "name": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection"
      },
      {
        "name": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedIssueAssociatedDesignConnection"
      },
      {
        "name": "GraphStoreSimplifiedIssueToWhiteboardConnection"
      },
      {
        "name": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalConnection"
      },
      {
        "name": "GraphStoreSimplifiedJswProjectAssociatedComponentConnection"
      },
      {
        "name": "GraphStoreSimplifiedJswProjectAssociatedIncidentConnection"
      },
      {
        "name": "GraphStoreSimplifiedProjectAssociatedRepoConnection"
      },
      {
        "name": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedTopicHasRelatedEntityConnection"
      },
      {
        "name": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedVersionAssociatedDesignConnection"
      },
      {
        "name": "JiraAssignableUsersConnection"
      },
      {
        "name": "JiraBulkEditFieldsConnection"
      },
      {
        "name": "JiraFormattingRuleConnection"
      },
      {
        "name": "JiraNavigationItemConnection"
      },
      {
        "name": "JiraNotificationProjectPreferenceConnection"
      },
      {
        "name": "JiraProjectConnection"
      },
      {
        "name": "JiraUserBroadcastMessageConnection"
      },
      {
        "name": "JiraWorkManagementSavedViewTypeConnection"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryRelatedEntitiesResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryRelatedEntityConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoverySearchRelatedEntitiesResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoverySearchRelatedEntities"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryKeyPhrasesResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryKeyPhraseConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryTeamSearchResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryTeam"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryUserSearchResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryUsers"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryPopularSearchQueryResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryPopularSearchQuery"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryZeroQueriesResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryZeroQueries"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryQuerySuggestionsResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryQuerySuggestions"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeDiscoveryIntentDetectionResult",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryIntentDetectionSuccess"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraProjectNavigationMetadata",
    "possibleTypes": [
      {
        "name": "JiraServiceManagementProjectNavigationMetadata"
      },
      {
        "name": "JiraSoftwareProjectNavigationMetadata"
      },
      {
        "name": "JiraWorkManagementProjectNavigationMetadata"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueField",
    "possibleTypes": [
      {
        "name": "JiraAffectedServicesField"
      },
      {
        "name": "JiraAggregatedStatusField"
      },
      {
        "name": "JiraAggregatedTimelineField"
      },
      {
        "name": "JiraAssetField"
      },
      {
        "name": "JiraAtlasProjectField"
      },
      {
        "name": "JiraAtlassianTeamField"
      },
      {
        "name": "JiraAttachmentsField"
      },
      {
        "name": "JiraBoardCardCoverMediaField"
      },
      {
        "name": "JiraBooleanField"
      },
      {
        "name": "JiraCMDBField"
      },
      {
        "name": "JiraCascadingSelectField"
      },
      {
        "name": "JiraCheckboxesField"
      },
      {
        "name": "JiraColorField"
      },
      {
        "name": "JiraCommentSummaryField"
      },
      {
        "name": "JiraComponentsField"
      },
      {
        "name": "JiraConfluenceRemoteIssueLinksField"
      },
      {
        "name": "JiraConnectDateTimeField"
      },
      {
        "name": "JiraConnectMultipleSelectField"
      },
      {
        "name": "JiraConnectNumberField"
      },
      {
        "name": "JiraConnectReadOnlyField"
      },
      {
        "name": "JiraConnectRichTextField"
      },
      {
        "name": "JiraConnectSingleSelectField"
      },
      {
        "name": "JiraConnectTextField"
      },
      {
        "name": "JiraCustomerServiceOrganizationField"
      },
      {
        "name": "JiraDataClassificationField"
      },
      {
        "name": "JiraDateFormulaField"
      },
      {
        "name": "JiraDatePickerField"
      },
      {
        "name": "JiraDateTimePickerField"
      },
      {
        "name": "JiraDevSummaryField"
      },
      {
        "name": "JiraDurationField"
      },
      {
        "name": "JiraEpicLinkField"
      },
      {
        "name": "JiraFallbackField"
      },
      {
        "name": "JiraFlagField"
      },
      {
        "name": "JiraForgeDateField"
      },
      {
        "name": "JiraForgeDatetimeField"
      },
      {
        "name": "JiraForgeGroupField"
      },
      {
        "name": "JiraForgeGroupsField"
      },
      {
        "name": "JiraForgeNumberField"
      },
      {
        "name": "JiraForgeObjectField"
      },
      {
        "name": "JiraForgeStringField"
      },
      {
        "name": "JiraForgeStringsField"
      },
      {
        "name": "JiraForgeUserField"
      },
      {
        "name": "JiraForgeUsersField"
      },
      {
        "name": "JiraGenericIssueField"
      },
      {
        "name": "JiraGoalsField"
      },
      {
        "name": "JiraIssueLinkField"
      },
      {
        "name": "JiraIssueLinkRelationshipTypeField"
      },
      {
        "name": "JiraIssueRestrictionField"
      },
      {
        "name": "JiraIssueTypeField"
      },
      {
        "name": "JiraLabelsField"
      },
      {
        "name": "JiraMultipleGroupPickerField"
      },
      {
        "name": "JiraMultipleSelectField"
      },
      {
        "name": "JiraMultipleSelectUserPickerField"
      },
      {
        "name": "JiraMultipleVersionPickerField"
      },
      {
        "name": "JiraNumberField"
      },
      {
        "name": "JiraNumberFormulaField"
      },
      {
        "name": "JiraOriginalTimeEstimateField"
      },
      {
        "name": "JiraParentIssueField"
      },
      {
        "name": "JiraPeopleField"
      },
      {
        "name": "JiraPriorityField"
      },
      {
        "name": "JiraProformaFormsField"
      },
      {
        "name": "JiraProjectField"
      },
      {
        "name": "JiraRadioSelectField"
      },
      {
        "name": "JiraRemainingTimeEstimateField"
      },
      {
        "name": "JiraResolutionField"
      },
      {
        "name": "JiraRichTextField"
      },
      {
        "name": "JiraSecurityLevelField"
      },
      {
        "name": "JiraServiceManagementApprovalField"
      },
      {
        "name": "JiraServiceManagementDateTimeField"
      },
      {
        "name": "JiraServiceManagementEntitlementField"
      },
      {
        "name": "JiraServiceManagementIncidentLinkingField"
      },
      {
        "name": "JiraServiceManagementMajorIncidentField"
      },
      {
        "name": "JiraServiceManagementMultipleSelectUserPickerField"
      },
      {
        "name": "JiraServiceManagementOrganizationField"
      },
      {
        "name": "JiraServiceManagementPeopleField"
      },
      {
        "name": "JiraServiceManagementRequestFeedbackField"
      },
      {
        "name": "JiraServiceManagementRequestLanguageField"
      },
      {
        "name": "JiraServiceManagementRequestTypeField"
      },
      {
        "name": "JiraServiceManagementRespondersField"
      },
      {
        "name": "JiraServiceManagementSentimentField"
      },
      {
        "name": "JiraSingleGroupPickerField"
      },
      {
        "name": "JiraSingleLineTextField"
      },
      {
        "name": "JiraSingleSelectField"
      },
      {
        "name": "JiraSingleSelectUserPickerField"
      },
      {
        "name": "JiraSingleVersionPickerField"
      },
      {
        "name": "JiraSprintField"
      },
      {
        "name": "JiraStatusCategoryField"
      },
      {
        "name": "JiraStatusField"
      },
      {
        "name": "JiraSubtaskSummaryField"
      },
      {
        "name": "JiraSubtasksField"
      },
      {
        "name": "JiraTeamField"
      },
      {
        "name": "JiraTeamViewField"
      },
      {
        "name": "JiraTextFormulaField"
      },
      {
        "name": "JiraTimeTrackingField"
      },
      {
        "name": "JiraTimelineField"
      },
      {
        "name": "JiraTownsquareProjectField"
      },
      {
        "name": "JiraUrlField"
      },
      {
        "name": "JiraVotesField"
      },
      {
        "name": "JiraWatchesField"
      },
      {
        "name": "JiraWorkCategoryField"
      },
      {
        "name": "JiraWorkLogField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueFieldConfiguration",
    "possibleTypes": [
      {
        "name": "JiraAffectedServicesField"
      },
      {
        "name": "JiraAssetField"
      },
      {
        "name": "JiraAtlasProjectField"
      },
      {
        "name": "JiraAtlassianTeamField"
      },
      {
        "name": "JiraAttachmentsField"
      },
      {
        "name": "JiraBooleanField"
      },
      {
        "name": "JiraCMDBField"
      },
      {
        "name": "JiraCascadingSelectField"
      },
      {
        "name": "JiraCheckboxesField"
      },
      {
        "name": "JiraColorField"
      },
      {
        "name": "JiraCommentSummaryField"
      },
      {
        "name": "JiraComponentsField"
      },
      {
        "name": "JiraConfluenceRemoteIssueLinksField"
      },
      {
        "name": "JiraConnectDateTimeField"
      },
      {
        "name": "JiraConnectMultipleSelectField"
      },
      {
        "name": "JiraConnectNumberField"
      },
      {
        "name": "JiraConnectReadOnlyField"
      },
      {
        "name": "JiraConnectRichTextField"
      },
      {
        "name": "JiraConnectSingleSelectField"
      },
      {
        "name": "JiraConnectTextField"
      },
      {
        "name": "JiraCustomerServiceOrganizationField"
      },
      {
        "name": "JiraDataClassificationField"
      },
      {
        "name": "JiraDateFormulaField"
      },
      {
        "name": "JiraDatePickerField"
      },
      {
        "name": "JiraDateTimePickerField"
      },
      {
        "name": "JiraDurationField"
      },
      {
        "name": "JiraEpicLinkField"
      },
      {
        "name": "JiraFallbackField"
      },
      {
        "name": "JiraFlagField"
      },
      {
        "name": "JiraForgeDateField"
      },
      {
        "name": "JiraForgeDatetimeField"
      },
      {
        "name": "JiraForgeGroupField"
      },
      {
        "name": "JiraForgeGroupsField"
      },
      {
        "name": "JiraForgeNumberField"
      },
      {
        "name": "JiraForgeObjectField"
      },
      {
        "name": "JiraForgeStringField"
      },
      {
        "name": "JiraForgeStringsField"
      },
      {
        "name": "JiraForgeUserField"
      },
      {
        "name": "JiraForgeUsersField"
      },
      {
        "name": "JiraGenericIssueField"
      },
      {
        "name": "JiraGoalsField"
      },
      {
        "name": "JiraIssueLinkField"
      },
      {
        "name": "JiraIssueLinkRelationshipTypeField"
      },
      {
        "name": "JiraIssueRestrictionField"
      },
      {
        "name": "JiraIssueTypeField"
      },
      {
        "name": "JiraLabelsField"
      },
      {
        "name": "JiraMultipleGroupPickerField"
      },
      {
        "name": "JiraMultipleSelectField"
      },
      {
        "name": "JiraMultipleSelectUserPickerField"
      },
      {
        "name": "JiraMultipleVersionPickerField"
      },
      {
        "name": "JiraNumberField"
      },
      {
        "name": "JiraNumberFormulaField"
      },
      {
        "name": "JiraOriginalTimeEstimateField"
      },
      {
        "name": "JiraParentIssueField"
      },
      {
        "name": "JiraPeopleField"
      },
      {
        "name": "JiraPriorityField"
      },
      {
        "name": "JiraProformaFormsField"
      },
      {
        "name": "JiraProjectField"
      },
      {
        "name": "JiraRadioSelectField"
      },
      {
        "name": "JiraRemainingTimeEstimateField"
      },
      {
        "name": "JiraResolutionField"
      },
      {
        "name": "JiraRichTextField"
      },
      {
        "name": "JiraSecurityLevelField"
      },
      {
        "name": "JiraServiceManagementApprovalField"
      },
      {
        "name": "JiraServiceManagementDateTimeField"
      },
      {
        "name": "JiraServiceManagementEntitlementField"
      },
      {
        "name": "JiraServiceManagementIncidentLinkingField"
      },
      {
        "name": "JiraServiceManagementMajorIncidentField"
      },
      {
        "name": "JiraServiceManagementMultipleSelectUserPickerField"
      },
      {
        "name": "JiraServiceManagementOrganizationField"
      },
      {
        "name": "JiraServiceManagementPeopleField"
      },
      {
        "name": "JiraServiceManagementRequestFeedbackField"
      },
      {
        "name": "JiraServiceManagementRequestLanguageField"
      },
      {
        "name": "JiraServiceManagementRequestTypeField"
      },
      {
        "name": "JiraServiceManagementRespondersField"
      },
      {
        "name": "JiraServiceManagementSentimentField"
      },
      {
        "name": "JiraSingleGroupPickerField"
      },
      {
        "name": "JiraSingleLineTextField"
      },
      {
        "name": "JiraSingleSelectField"
      },
      {
        "name": "JiraSingleSelectUserPickerField"
      },
      {
        "name": "JiraSingleVersionPickerField"
      },
      {
        "name": "JiraSprintField"
      },
      {
        "name": "JiraStatusCategoryField"
      },
      {
        "name": "JiraStatusField"
      },
      {
        "name": "JiraSubtasksField"
      },
      {
        "name": "JiraTeamField"
      },
      {
        "name": "JiraTeamViewField"
      },
      {
        "name": "JiraTextFormulaField"
      },
      {
        "name": "JiraTimeTrackingField"
      },
      {
        "name": "JiraTimelineField"
      },
      {
        "name": "JiraTownsquareProjectField"
      },
      {
        "name": "JiraUrlField"
      },
      {
        "name": "JiraVotesField"
      },
      {
        "name": "JiraWatchesField"
      },
      {
        "name": "JiraWorkCategoryField"
      },
      {
        "name": "JiraWorkLogField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraUserIssueFieldConfiguration",
    "possibleTypes": [
      {
        "name": "JiraAffectedServicesField"
      },
      {
        "name": "JiraAssetField"
      },
      {
        "name": "JiraAtlasProjectField"
      },
      {
        "name": "JiraAtlassianTeamField"
      },
      {
        "name": "JiraAttachmentsField"
      },
      {
        "name": "JiraBooleanField"
      },
      {
        "name": "JiraCascadingSelectField"
      },
      {
        "name": "JiraCheckboxesField"
      },
      {
        "name": "JiraColorField"
      },
      {
        "name": "JiraComponentsField"
      },
      {
        "name": "JiraConnectDateTimeField"
      },
      {
        "name": "JiraConnectMultipleSelectField"
      },
      {
        "name": "JiraConnectNumberField"
      },
      {
        "name": "JiraConnectReadOnlyField"
      },
      {
        "name": "JiraConnectRichTextField"
      },
      {
        "name": "JiraConnectSingleSelectField"
      },
      {
        "name": "JiraConnectTextField"
      },
      {
        "name": "JiraCustomerServiceOrganizationField"
      },
      {
        "name": "JiraDataClassificationField"
      },
      {
        "name": "JiraDateFormulaField"
      },
      {
        "name": "JiraDatePickerField"
      },
      {
        "name": "JiraDateTimePickerField"
      },
      {
        "name": "JiraDurationField"
      },
      {
        "name": "JiraEpicLinkField"
      },
      {
        "name": "JiraFlagField"
      },
      {
        "name": "JiraForgeDateField"
      },
      {
        "name": "JiraForgeDatetimeField"
      },
      {
        "name": "JiraForgeGroupField"
      },
      {
        "name": "JiraForgeGroupsField"
      },
      {
        "name": "JiraForgeNumberField"
      },
      {
        "name": "JiraForgeObjectField"
      },
      {
        "name": "JiraForgeStringField"
      },
      {
        "name": "JiraForgeStringsField"
      },
      {
        "name": "JiraForgeUserField"
      },
      {
        "name": "JiraForgeUsersField"
      },
      {
        "name": "JiraGoalsField"
      },
      {
        "name": "JiraIssueLinkField"
      },
      {
        "name": "JiraIssueRestrictionField"
      },
      {
        "name": "JiraLabelsField"
      },
      {
        "name": "JiraMultipleGroupPickerField"
      },
      {
        "name": "JiraMultipleSelectField"
      },
      {
        "name": "JiraMultipleSelectUserPickerField"
      },
      {
        "name": "JiraMultipleVersionPickerField"
      },
      {
        "name": "JiraNumberField"
      },
      {
        "name": "JiraNumberFormulaField"
      },
      {
        "name": "JiraOriginalTimeEstimateField"
      },
      {
        "name": "JiraParentIssueField"
      },
      {
        "name": "JiraPeopleField"
      },
      {
        "name": "JiraPriorityField"
      },
      {
        "name": "JiraProformaFormsField"
      },
      {
        "name": "JiraProjectField"
      },
      {
        "name": "JiraRadioSelectField"
      },
      {
        "name": "JiraRemainingTimeEstimateField"
      },
      {
        "name": "JiraResolutionField"
      },
      {
        "name": "JiraRichTextField"
      },
      {
        "name": "JiraSecurityLevelField"
      },
      {
        "name": "JiraServiceManagementApprovalField"
      },
      {
        "name": "JiraServiceManagementDateTimeField"
      },
      {
        "name": "JiraServiceManagementEntitlementField"
      },
      {
        "name": "JiraServiceManagementMajorIncidentField"
      },
      {
        "name": "JiraServiceManagementMultipleSelectUserPickerField"
      },
      {
        "name": "JiraServiceManagementOrganizationField"
      },
      {
        "name": "JiraServiceManagementPeopleField"
      },
      {
        "name": "JiraServiceManagementRequestFeedbackField"
      },
      {
        "name": "JiraServiceManagementRequestLanguageField"
      },
      {
        "name": "JiraServiceManagementSentimentField"
      },
      {
        "name": "JiraSingleGroupPickerField"
      },
      {
        "name": "JiraSingleLineTextField"
      },
      {
        "name": "JiraSingleSelectField"
      },
      {
        "name": "JiraSingleSelectUserPickerField"
      },
      {
        "name": "JiraSingleVersionPickerField"
      },
      {
        "name": "JiraSprintField"
      },
      {
        "name": "JiraStatusCategoryField"
      },
      {
        "name": "JiraStatusField"
      },
      {
        "name": "JiraTeamField"
      },
      {
        "name": "JiraTeamViewField"
      },
      {
        "name": "JiraTextFormulaField"
      },
      {
        "name": "JiraTimeTrackingField"
      },
      {
        "name": "JiraTownsquareProjectField"
      },
      {
        "name": "JiraUrlField"
      },
      {
        "name": "JiraVotesField"
      },
      {
        "name": "JiraWatchesField"
      },
      {
        "name": "JiraWorkLogField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "HasTotal",
    "possibleTypes": [
      {
        "name": "GraphStoreSimplifiedIssueAssociatedDesignConnection"
      },
      {
        "name": "GraphStoreSimplifiedIssueToWhiteboardConnection"
      },
      {
        "name": "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalConnection"
      },
      {
        "name": "GraphStoreSimplifiedJswProjectAssociatedComponentConnection"
      },
      {
        "name": "GraphStoreSimplifiedJswProjectAssociatedIncidentConnection"
      },
      {
        "name": "GraphStoreSimplifiedProjectAssociatedRepoConnection"
      },
      {
        "name": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection"
      },
      {
        "name": "GraphStoreSimplifiedVersionAssociatedDesignConnection"
      },
      {
        "name": "JiraAssignableUsersConnection"
      },
      {
        "name": "JiraBulkEditFieldsConnection"
      },
      {
        "name": "JiraNotificationProjectPreferenceConnection"
      },
      {
        "name": "JiraProjectConnection"
      },
      {
        "name": "JiraUserBroadcastMessageConnection"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueError",
    "possibleTypes": [
      {
        "name": "JiraRemoteLinkedIssueError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueSearchError",
    "possibleTypes": [
      {
        "name": "JiraCustomIssueSearchError"
      },
      {
        "name": "JiraInvalidIssueSearchInputError"
      },
      {
        "name": "JiraInvalidJqlError"
      },
      {
        "name": "JiraInvalidSyntaxError"
      },
      {
        "name": "JiraServerError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "QueryErrorExtension",
    "possibleTypes": [
      {
        "name": "AdminApplicationErrorExtension"
      },
      {
        "name": "CplsQueryErrorExtension"
      },
      {
        "name": "GenericQueryErrorExtension"
      },
      {
        "name": "HelpLayoutQueryErrorExtension"
      },
      {
        "name": "JiraIssueCommandPaletteActionUnsupportedErrorExtension"
      },
      {
        "name": "JiraIssueFieldUnsupportedErrorExtension"
      },
      {
        "name": "JiraIssueSearchErrorExtension"
      },
      {
        "name": "JiraVersionConnectionResultQueryErrorExtension"
      },
      {
        "name": "LpConnectionQueryErrorExtension"
      },
      {
        "name": "ShepherdGenericQueryErrorExtension"
      },
      {
        "name": "ToolchainCheckAuthErrorExtension"
      },
      {
        "name": "ToolchainContainerConnectionErrorExtension"
      },
      {
        "name": "ToolchainWorkspaceConnectionErrorExtension"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraEmptyConnectionReason",
    "possibleTypes": [
      {
        "name": "JiraDefaultEmptyConnectionReason"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueAISummaryResult",
    "possibleTypes": [
      {
        "name": "JiraIssueAISummary"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MercuryProjectStatus",
    "possibleTypes": [
      {
        "name": "JiraAlignAggMercuryProjectStatusDto"
      },
      {
        "name": "JiraStatusCategory"
      },
      {
        "name": "TownsquareMercuryProjectStatusDto"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MercuryOriginalProjectStatus",
    "possibleTypes": [
      {
        "name": "JiraAlignAggMercuryOriginalProjectStatusDTO"
      },
      {
        "name": "JiraStatus"
      },
      {
        "name": "TownsquareMercuryOriginalProjectStatusDto"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraMediaUploadTokenResult",
    "possibleTypes": [
      {
        "name": "JiraMediaUploadToken"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueCommandPaletteAction",
    "possibleTypes": [
      {
        "name": "JiraIssueCommandPaletteUpdateFieldAction"
      },
      {
        "name": "JiraIssueGenericCommandPaletteAction"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueFieldsByContainerTypesResult",
    "possibleTypes": [
      {
        "name": "JiraIssueFieldsByContainerTypes"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraComment",
    "possibleTypes": [
      {
        "name": "JiraPlatformComment"
      },
      {
        "name": "JiraServiceManagementComment"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraAttachment",
    "possibleTypes": [
      {
        "name": "JiraPlatformAttachment"
      },
      {
        "name": "JiraServiceManagementAttachment"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraChildIssues",
    "possibleTypes": [
      {
        "name": "JiraChildIssuesExceedingLimit"
      },
      {
        "name": "JiraChildIssuesWithinLimit"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "DevOpsDataProvider",
    "possibleTypes": [
      {
        "name": "DevOpsBuildProvider"
      },
      {
        "name": "DevOpsComponentsProvider"
      },
      {
        "name": "DevOpsDeploymentProvider"
      },
      {
        "name": "DevOpsDesignProvider"
      },
      {
        "name": "DevOpsDevInfoProvider"
      },
      {
        "name": "DevOpsDocumentationProvider"
      },
      {
        "name": "DevOpsFeatureFlagProvider"
      },
      {
        "name": "DevOpsOperationsProvider"
      },
      {
        "name": "DevOpsRemoteLinksProvider"
      },
      {
        "name": "DevOpsSecurityProvider"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "AriGraphRelationshipNodeData",
    "possibleTypes": [
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceSpace"
      },
      {
        "name": "DeploymentSummary"
      },
      {
        "name": "DevOpsDesign"
      },
      {
        "name": "DevOpsDocument"
      },
      {
        "name": "DevOpsFeatureFlag"
      },
      {
        "name": "DevOpsOperationsComponentDetails"
      },
      {
        "name": "DevOpsOperationsIncidentDetails"
      },
      {
        "name": "DevOpsOperationsPostIncidentReviewDetails"
      },
      {
        "name": "DevOpsPullRequestDetails"
      },
      {
        "name": "DevOpsRepository"
      },
      {
        "name": "DevOpsSecurityVulnerabilityDetails"
      },
      {
        "name": "DevOpsService"
      },
      {
        "name": "ExternalCommit"
      },
      {
        "name": "JiraAutodevJob"
      },
      {
        "name": "JiraConfluenceRemoteIssueLink"
      },
      {
        "name": "JiraCustomRemoteIssueLink"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraIssueRemoteIssueLink"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraVersion"
      },
      {
        "name": "JiraWebRemoteIssueLink"
      },
      {
        "name": "OpsgenieTeam"
      },
      {
        "name": "ThirdPartySecurityContainer"
      },
      {
        "name": "ThirdPartySecurityWorkspace"
      },
      {
        "name": "TownsquareComment"
      },
      {
        "name": "TownsquareGoal"
      },
      {
        "name": "TownsquareProject"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedJswProjectAssociatedComponentUnion",
    "possibleTypes": [
      {
        "name": "CompassComponent"
      },
      {
        "name": "DevOpsOperationsComponentDetails"
      },
      {
        "name": "DevOpsService"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphRelationshipNodeData",
    "possibleTypes": [
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceSpace"
      },
      {
        "name": "DeploymentSummary"
      },
      {
        "name": "DevOpsDocument"
      },
      {
        "name": "DevOpsFeatureFlag"
      },
      {
        "name": "DevOpsOperationsComponentDetails"
      },
      {
        "name": "DevOpsOperationsIncidentDetails"
      },
      {
        "name": "DevOpsOperationsPostIncidentReviewDetails"
      },
      {
        "name": "DevOpsPullRequestDetails"
      },
      {
        "name": "DevOpsRepository"
      },
      {
        "name": "DevOpsSecurityVulnerabilityDetails"
      },
      {
        "name": "DevOpsService"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraPostIncidentReviewLink"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraVersion"
      },
      {
        "name": "OpsgenieTeam"
      },
      {
        "name": "ThirdPartySecurityContainer"
      },
      {
        "name": "ThirdPartySecurityWorkspace"
      },
      {
        "name": "TownsquareComment"
      },
      {
        "name": "TownsquareGoal"
      },
      {
        "name": "TownsquareProject"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedIssueToWhiteboardUnion",
    "possibleTypes": [
      {
        "name": "ConfluenceWhiteboard"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraWorkManagementBackground",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementAttachmentBackground"
      },
      {
        "name": "JiraWorkManagementColorBackground"
      },
      {
        "name": "JiraWorkManagementGradientBackground"
      },
      {
        "name": "JiraWorkManagementMediaBackground"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraBackground",
    "possibleTypes": [
      {
        "name": "JiraAttachmentBackground"
      },
      {
        "name": "JiraColorBackground"
      },
      {
        "name": "JiraGradientBackground"
      },
      {
        "name": "JiraMediaBackground"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MercuryProjectType",
    "possibleTypes": [
      {
        "name": "JiraAlignAggMercuryProjectTypeDTO"
      },
      {
        "name": "JiraIssueType"
      },
      {
        "name": "TownsquareMercuryProjectTypeDto"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedIssueAssociatedDesignUnion",
    "possibleTypes": [
      {
        "name": "DevOpsDesign"
      },
      {
        "name": "ExternalDesign"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueSearchViewContextMapping",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchViewContextMappingByGroup"
      },
      {
        "name": "JiraIssueSearchViewContextMappingByParent"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraSpreadsheetGroupFieldValue",
    "possibleTypes": [
      {
        "name": "JiraGoal"
      },
      {
        "name": "JiraOption"
      },
      {
        "name": "JiraPriority"
      },
      {
        "name": "JiraStatus"
      },
      {
        "name": "JiraStoryPoint"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraJqlFieldValue",
    "possibleTypes": [
      {
        "name": "JiraJqlAtlasProjectFieldValue"
      },
      {
        "name": "JiraJqlCascadingOptionFieldValue"
      },
      {
        "name": "JiraJqlComponentFieldValue"
      },
      {
        "name": "JiraJqlDateBucketFieldValue"
      },
      {
        "name": "JiraJqlEmptyFieldValue"
      },
      {
        "name": "JiraJqlFunctionFieldValue"
      },
      {
        "name": "JiraJqlGoalsFieldValue"
      },
      {
        "name": "JiraJqlGroupFieldValue"
      },
      {
        "name": "JiraJqlIssueFieldValue"
      },
      {
        "name": "JiraJqlIssueTypeFieldValue"
      },
      {
        "name": "JiraJqlLabelFieldValue"
      },
      {
        "name": "JiraJqlNumberFieldValue"
      },
      {
        "name": "JiraJqlOptionFieldValue"
      },
      {
        "name": "JiraJqlPlainTextFieldValue"
      },
      {
        "name": "JiraJqlPriorityFieldValue"
      },
      {
        "name": "JiraJqlProjectFieldValue"
      },
      {
        "name": "JiraJqlResolutionFieldValue"
      },
      {
        "name": "JiraJqlSprintFieldValue"
      },
      {
        "name": "JiraJqlStatusCategoryFieldValue"
      },
      {
        "name": "JiraJqlStatusFieldValue"
      },
      {
        "name": "JiraJqlTeamFieldValue"
      },
      {
        "name": "JiraJqlTownsquareProjectFieldValue"
      },
      {
        "name": "JiraJqlUserFieldValue"
      },
      {
        "name": "JiraJqlVersionFieldValue"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConvoAiAgentSessionNode",
    "possibleTypes": [
      {
        "name": "ConvoAiAgentSession"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraAllActivityFeedItemUnion",
    "possibleTypes": [
      {
        "name": "JiraApprovalItem"
      },
      {
        "name": "JiraCommentItem"
      },
      {
        "name": "JiraHiddenCommentItem"
      },
      {
        "name": "JiraHistoryItem"
      },
      {
        "name": "JiraWorklogItem"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraHistoryValue",
    "possibleTypes": [
      {
        "name": "JiraHistoryAssigneeFieldValue"
      },
      {
        "name": "JiraHistoryGenericFieldValue"
      },
      {
        "name": "JiraHistoryPriorityFieldValue"
      },
      {
        "name": "JiraHistoryRespondersFieldValue"
      },
      {
        "name": "JiraHistoryStatusFieldValue"
      },
      {
        "name": "JiraHistoryWorkLogFieldValue"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraConfluencePageContent",
    "possibleTypes": [
      {
        "name": "JiraConfluencePageContentDetails"
      },
      {
        "name": "JiraConfluencePageContentError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraScenarioIssueLike",
    "possibleTypes": [
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraScenarioIssue"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "HasMercuryProjectFields",
    "possibleTypes": [
      {
        "name": "JiraIssue"
      },
      {
        "name": "TownsquareProject"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementSavedViewResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementSavedView"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraNavigationItemResult",
    "possibleTypes": [
      {
        "name": "JiraAppNavigationItem"
      },
      {
        "name": "JiraShortcutNavigationItem"
      },
      {
        "name": "JiraSoftwareBuiltInNavigationItem"
      },
      {
        "name": "JiraWorkManagementSavedView"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraVersionRelatedWorkV2",
    "possibleTypes": [
      {
        "name": "JiraVersionRelatedWorkConfluenceReleaseNotes"
      },
      {
        "name": "JiraVersionRelatedWorkGenericLink"
      },
      {
        "name": "JiraVersionRelatedWorkNativeReleaseNotes"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedVersionAssociatedDesignUnion",
    "possibleTypes": [
      {
        "name": "DevOpsDesign"
      },
      {
        "name": "ExternalDesign"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraScenarioVersionLike",
    "possibleTypes": [
      {
        "name": "JiraScenarioVersion"
      },
      {
        "name": "JiraVersion"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraSelectableValue",
    "possibleTypes": [
      {
        "name": "JiraAffectedService"
      },
      {
        "name": "JiraOption"
      },
      {
        "name": "JiraParentOption"
      },
      {
        "name": "JiraServiceManagementOrganization"
      },
      {
        "name": "JiraVersion"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraVersionConnectionResult",
    "possibleTypes": [
      {
        "name": "JiraVersionConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraBoardResult",
    "possibleTypes": [
      {
        "name": "JiraBoard"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraActiveBackgroundDetailsResult",
    "possibleTypes": [
      {
        "name": "JiraAttachmentBackground"
      },
      {
        "name": "JiraColorBackground"
      },
      {
        "name": "JiraGradientBackground"
      },
      {
        "name": "JiraMediaBackground"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedTeamConnectedToContainerInverseUnion",
    "possibleTypes": [
      {
        "name": "TeamV2"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalUnion",
    "possibleTypes": [
      {
        "name": "TownsquareGoal"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SecurityContainer",
    "possibleTypes": [
      {
        "name": "ThirdPartySecurityContainer"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedJswProjectAssociatedIncidentUnion",
    "possibleTypes": [
      {
        "name": "DevOpsOperationsIncidentDetails"
      },
      {
        "name": "JiraIssue"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CodeRepository",
    "possibleTypes": [
      {
        "name": "BitbucketRepository"
      },
      {
        "name": "DevOpsThirdPartyRepository"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "BaseSprint",
    "possibleTypes": [
      {
        "name": "Sprint"
      },
      {
        "name": "SprintWithStatistics"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "BoardFeatureView",
    "possibleTypes": [
      {
        "name": "BasicBoardFeatureView"
      },
      {
        "name": "EstimationBoardFeatureView"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "Admin",
    "possibleTypes": [
      {
        "name": "JiraUser"
      },
      {
        "name": "JiraUserGroup"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "VirtualAgentConfigurationResult",
    "possibleTypes": [
      {
        "name": "VirtualAgentConfiguration"
      },
      {
        "name": "VirtualAgentQueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "GraphStoreSimplifiedProjectAssociatedRepoUnion",
    "possibleTypes": [
      {
        "name": "DevOpsRepository"
      },
      {
        "name": "ExternalRepository"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraFormattingExpression",
    "possibleTypes": [
      {
        "name": "JiraFormattingMultipleValueOperand"
      },
      {
        "name": "JiraFormattingNoValueOperand"
      },
      {
        "name": "JiraFormattingSingleValueOperand"
      },
      {
        "name": "JiraFormattingTwoValueOperand"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "KnowledgeBaseArticleCountResponse",
    "possibleTypes": [
      {
        "name": "KnowledgeBaseArticleCountError"
      },
      {
        "name": "KnowledgeBaseArticleCountSource"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraFieldFormatConfig",
    "possibleTypes": [
      {
        "name": "JiraNumberFieldFormatConfig"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraProjectFieldAssociationInterface",
    "possibleTypes": [
      {
        "name": "JiraAvailableField"
      },
      {
        "name": "JiraFieldAssociationWithIssueTypes"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraProjectRecommendationDetails",
    "possibleTypes": [
      {
        "name": "JiraInviterActivityRecommendation"
      },
      {
        "name": "JiraTenantActivityRecommendation"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraAtlassianIntelligenceAction",
    "possibleTypes": [
      {
        "name": "JiraAccessAtlassianIntelligenceFeature"
      },
      {
        "name": "JiraContactOrgAdminToEnableAtlassianIntelligence"
      },
      {
        "name": "JiraEnableAtlassianIntelligenceDeepLink"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraNavigationItem",
    "possibleTypes": [
      {
        "name": "JiraAppNavigationItem"
      },
      {
        "name": "JiraShortcutNavigationItem"
      },
      {
        "name": "JiraSoftwareBuiltInNavigationItem"
      },
      {
        "name": "JiraWorkManagementSavedView"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraRecommendedActionEntity",
    "possibleTypes": [
      {
        "name": "ExternalPullRequest"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraPlatformComment"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraServiceManagementComment"
      },
      {
        "name": "TeamV2"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraContainerNavigationResult",
    "possibleTypes": [
      {
        "name": "JiraContainerNavigation"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraVersionResult",
    "possibleTypes": [
      {
        "name": "JiraVersion"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraHasSelectableValueOptions",
    "possibleTypes": [
      {
        "name": "JiraAffectedServicesField"
      },
      {
        "name": "JiraCascadingSelectField"
      },
      {
        "name": "JiraConnectMultipleSelectField"
      },
      {
        "name": "JiraConnectSingleSelectField"
      },
      {
        "name": "JiraMultipleSelectField"
      },
      {
        "name": "JiraMultipleVersionPickerField"
      },
      {
        "name": "JiraParentOption"
      },
      {
        "name": "JiraServiceManagementOrganizationField"
      },
      {
        "name": "JiraSingleSelectField"
      },
      {
        "name": "JiraSingleVersionPickerField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraResourceUsageMetricV2",
    "possibleTypes": [
      {
        "name": "JiraCustomFieldUsageMetric"
      },
      {
        "name": "JiraGenericResourceUsageMetric"
      },
      {
        "name": "JiraWorkTypeUsageMetric"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueSearchBulkViewContexts",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchBulkViewGroupContexts"
      },
      {
        "name": "JiraIssueSearchBulkViewParentContexts"
      },
      {
        "name": "JiraIssueSearchBulkViewTopLevelContexts"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraCFOAnalyticsResult",
    "possibleTypes": [
      {
        "name": "JiraCFOBoardPerformanceAnalyticsResult"
      },
      {
        "name": "JiraCFODefaultAnalyticsResult"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraCFODataRow",
    "possibleTypes": [
      {
        "name": "JiraCFOBoardPerformanceDataRow"
      },
      {
        "name": "JiraCFODefaultDataRow"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraCFOMetricSummary",
    "possibleTypes": [
      {
        "name": "JiraCFOBoardPerformanceMetricSummary"
      },
      {
        "name": "JiraCFODefaultMetricSummary"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraFilter",
    "possibleTypes": [
      {
        "name": "JiraCustomFilter"
      },
      {
        "name": "JiraSystemFilter"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraFavourite",
    "possibleTypes": [
      {
        "name": "JiraBoard"
      },
      {
        "name": "JiraCustomFilter"
      },
      {
        "name": "JiraDashboard"
      },
      {
        "name": "JiraPlan"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraServiceManagementQueue"
      },
      {
        "name": "JiraSystemFilter"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraGlobalPermissionGrantsResult",
    "possibleTypes": [
      {
        "name": "JiraGlobalPermissionGrantsList"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraGrantTypeValue",
    "possibleTypes": [
      {
        "name": "JiraDefaultGrantTypeValue"
      },
      {
        "name": "JiraGroupGrantTypeValue"
      },
      {
        "name": "JiraIssueFieldGrantTypeValue"
      },
      {
        "name": "JiraProjectRoleGrantTypeValue"
      },
      {
        "name": "JiraUserGrantTypeValue"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraPermissionSchemeViewResult",
    "possibleTypes": [
      {
        "name": "JiraPermissionSchemeView"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraFormulaFieldValue",
    "possibleTypes": [
      {
        "name": "JiraFormulaFieldDateValue"
      },
      {
        "name": "JiraFormulaFieldNumberValue"
      },
      {
        "name": "JiraFormulaFieldTextValue"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJqlHydratedQueryResult",
    "possibleTypes": [
      {
        "name": "JiraJqlHydratedQuery"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJqlFieldConnectionResult",
    "possibleTypes": [
      {
        "name": "JiraJqlFieldConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "DevAiAutodevLog",
    "possibleTypes": [
      {
        "name": "DevAiGenericAutodevLog"
      },
      {
        "name": "DevAiPhaseEndedAutodevLog"
      },
      {
        "name": "DevAiPhaseStartedAutodevLog"
      },
      {
        "name": "DevAiPlaintextAutodevLog"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraSearchableEntity",
    "possibleTypes": [
      {
        "name": "JiraBoard"
      },
      {
        "name": "JiraCustomFilter"
      },
      {
        "name": "JiraDashboard"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraPlan"
      },
      {
        "name": "JiraProject"
      },
      {
        "name": "JiraServiceManagementQueue"
      },
      {
        "name": "JiraSystemFilter"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraBackgroundUploadTokenResult",
    "possibleTypes": [
      {
        "name": "JiraBackgroundUploadToken"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraUnsplashImageSearchPageResult",
    "possibleTypes": [
      {
        "name": "JiraUnsplashImageSearchPage"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraDefaultUnsplashImagesPageResult",
    "possibleTypes": [
      {
        "name": "JiraDefaultUnsplashImagesPage"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueSearchByJqlResult",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchByJql"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueSearchByFilterResult",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchByFilter"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueSearchViewMetadata",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchView"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueSearchResultContent",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchContextlessContent"
      },
      {
        "name": "JiraIssueSearchContextualContent"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraIssueSearchResult",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchByFilter"
      },
      {
        "name": "JiraIssueSearchByHydration"
      },
      {
        "name": "JiraIssueSearchByJql"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraFieldSetViewResult",
    "possibleTypes": [
      {
        "name": "JiraFieldSetView"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueSearchViewResult",
    "possibleTypes": [
      {
        "name": "JiraIssueSearchView"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJQLGenerationError",
    "possibleTypes": [
      {
        "name": "JiraGeneratedJqlInvalidError"
      },
      {
        "name": "JiraInvalidJqlError"
      },
      {
        "name": "JiraInvalidSyntaxError"
      },
      {
        "name": "JiraServerError"
      },
      {
        "name": "JiraUIExposedError"
      },
      {
        "name": "JiraUnsupportedLanguageError"
      },
      {
        "name": "JiraUsageLimitExceededError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraView",
    "possibleTypes": [
      {
        "name": "JiraBoardView"
      },
      {
        "name": "JiraDetailedView"
      },
      {
        "name": "JiraGroupedListView"
      },
      {
        "name": "JiraListView"
      },
      {
        "name": "JiraTimelineView"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraServiceManagementRequestTypePreviewField",
    "possibleTypes": [
      {
        "name": "JiraServiceManagementAttachmentPreviewField"
      },
      {
        "name": "JiraServiceManagementDatePreviewField"
      },
      {
        "name": "JiraServiceManagementDateTimePreviewField"
      },
      {
        "name": "JiraServiceManagementDueDatePreviewField"
      },
      {
        "name": "JiraServiceManagementMultiCheckboxesPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiSelectPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiServicePickerPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiUserPickerPreviewField"
      },
      {
        "name": "JiraServiceManagementPeoplePreviewField"
      },
      {
        "name": "JiraServiceManagementSelectPreviewField"
      },
      {
        "name": "JiraServiceManagementTextAreaPreviewField"
      },
      {
        "name": "JiraServiceManagementTextPreviewField"
      },
      {
        "name": "JiraServiceManagementUnknownPreviewField"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementGiraOverviewResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementGiraOverview"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraFieldContextualData",
    "possibleTypes": [
      {
        "name": "JiraFieldContextualDataTeamsFilter"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraEntityProperty",
    "possibleTypes": [
      {
        "name": "JiraEntityPropertyBoolean"
      },
      {
        "name": "JiraEntityPropertyInt"
      },
      {
        "name": "JiraEntityPropertyJSON"
      },
      {
        "name": "JiraEntityPropertyString"
      },
      {
        "name": "JiraNavigationUIStateUserProperty"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraDevOpsProvider",
    "possibleTypes": [
      {
        "name": "JiraBitbucketDevOpsProvider"
      },
      {
        "name": "JiraClassicConnectDevOpsProvider"
      },
      {
        "name": "JiraOAuthDevOpsProvider"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraIssueItemContainersResult",
    "possibleTypes": [
      {
        "name": "JiraIssueItemContainers"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraOverviewPlanMigrationStateResult",
    "possibleTypes": [
      {
        "name": "JiraOverviewPlanMigrationState"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementViewItemConnectionResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementViewItemConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementFilterConnectionResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementFilterConnection"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJourneyTriggerConfiguration",
    "possibleTypes": [
      {
        "name": "JiraJourneyParentIssueTriggerConfiguration"
      },
      {
        "name": "JiraJourneyWorkdayIntegrationTriggerConfiguration"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJourneyParentIssueValueType",
    "possibleTypes": [
      {
        "name": "JiraServiceManagementRequestType"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraJourneyItem",
    "possibleTypes": [
      {
        "name": "JiraJourneyStatusDependency"
      },
      {
        "name": "JiraJourneyWorkItem"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraRemoteIssueLink",
    "possibleTypes": [
      {
        "name": "JiraConfluenceRemoteIssueLink"
      },
      {
        "name": "JiraCustomRemoteIssueLink"
      },
      {
        "name": "JiraIssueRemoteIssueLink"
      },
      {
        "name": "JiraWebRemoteIssueLink"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementBackgroundUploadTokenResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementBackgroundUploadToken"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "JiraWorkManagementActiveBackgroundDetailsResult",
    "possibleTypes": [
      {
        "name": "JiraWorkManagementAttachmentBackground"
      },
      {
        "name": "JiraWorkManagementColorBackground"
      },
      {
        "name": "JiraWorkManagementGradientBackground"
      },
      {
        "name": "JiraWorkManagementMediaBackground"
      },
      {
        "name": "QueryError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SpaceRolePrincipal",
    "possibleTypes": [
      {
        "name": "ConfluenceSpaceRoleAppPrincipal"
      },
      {
        "name": "SpaceRoleAccessClassPrincipal"
      },
      {
        "name": "SpaceRoleGroupPrincipal"
      },
      {
        "name": "SpaceRoleGuestPrincipal"
      },
      {
        "name": "SpaceRoleUserPrincipal"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SmartLink",
    "possibleTypes": [
      {
        "name": "BlockSmartLink"
      },
      {
        "name": "EmbeddedSmartLink"
      },
      {
        "name": "InlineSmartLink"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ActivitiesEventExtension",
    "possibleTypes": [
      {
        "name": "ActivitiesCommentedEvent"
      },
      {
        "name": "ActivitiesTransitionedEvent"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ActivitiesObjectExtension",
    "possibleTypes": [
      {
        "name": "ActivitiesJiraIssue"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ActivityObjectData",
    "possibleTypes": [
      {
        "name": "AssetsObject"
      },
      {
        "name": "AssetsObjectType"
      },
      {
        "name": "AssetsSchema"
      },
      {
        "name": "BitbucketPullRequest"
      },
      {
        "name": "CompassComponent"
      },
      {
        "name": "ConfluenceBlogPost"
      },
      {
        "name": "ConfluenceDatabase"
      },
      {
        "name": "ConfluenceEmbed"
      },
      {
        "name": "ConfluenceFooterComment"
      },
      {
        "name": "ConfluenceInlineComment"
      },
      {
        "name": "ConfluencePage"
      },
      {
        "name": "ConfluenceWhiteboard"
      },
      {
        "name": "DevOpsDesign"
      },
      {
        "name": "DevOpsDocument"
      },
      {
        "name": "DevOpsPullRequestDetails"
      },
      {
        "name": "ExternalDocument"
      },
      {
        "name": "ExternalRemoteLink"
      },
      {
        "name": "JiraIssue"
      },
      {
        "name": "JiraPlatformComment"
      },
      {
        "name": "JiraServiceManagementComment"
      },
      {
        "name": "LoomVideo"
      },
      {
        "name": "MercuryFocusArea"
      },
      {
        "name": "MercuryPortfolio"
      },
      {
        "name": "TownsquareComment"
      },
      {
        "name": "TownsquareGoal"
      },
      {
        "name": "TownsquareProject"
      },
      {
        "name": "TrelloAttachment"
      },
      {
        "name": "TrelloBoard"
      },
      {
        "name": "TrelloCard"
      },
      {
        "name": "TrelloLabel"
      },
      {
        "name": "TrelloList"
      },
      {
        "name": "TrelloMember"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "MutationErrorExtension",
    "possibleTypes": [
      {
        "name": "AdminAnnouncementBannerMutationErrorExtension"
      },
      {
        "name": "AdminApplicationErrorExtension"
      },
      {
        "name": "AriGraphRelationshipsMutationErrorExtension"
      },
      {
        "name": "BulkMutationErrorExtension"
      },
      {
        "name": "ConfluenceCalendarFieldMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateContentAccessRequestMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateCustomContentPermissionsMutationErrorExtension"
      },
      {
        "name": "ConfluenceUpdateSiteConfigurationMutationErrorExtension"
      },
      {
        "name": "CplsMutationErrorExtension"
      },
      {
        "name": "CustomerServiceCustomDetailCreateErrorExtension"
      },
      {
        "name": "DevAiGenericMutationErrorExtension"
      },
      {
        "name": "GenericMutationErrorExtension"
      },
      {
        "name": "HelpLayoutMutationErrorExtension"
      },
      {
        "name": "InsightsMutationErrorExtension"
      },
      {
        "name": "InvokeExtensionPayloadErrorExtension"
      },
      {
        "name": "JiraFieldValidationMutationErrorExtension"
      },
      {
        "name": "JiraFilterEditGrantMutationErrorExtension"
      },
      {
        "name": "JiraFilterNameMutationErrorExtension"
      },
      {
        "name": "JiraFilterShareGrantMutationErrorExtension"
      },
      {
        "name": "JiraIssueArchiveAsyncErrorExtension"
      },
      {
        "name": "JiraIssueArchiveErrorExtension"
      },
      {
        "name": "JiraIssueUnarchiveErrorExtension"
      },
      {
        "name": "JiraListSettingMigrationMutationErrorExtension"
      },
      {
        "name": "KnowledgeDiscoveryBookmarkMutationErrorExtension"
      },
      {
        "name": "ReopenCommentsMutationErrorExtension"
      },
      {
        "name": "ResolveCommentsMutationErrorExtension"
      },
      {
        "name": "ResolveRestrictionsForSubjectMutationErrorExtension"
      },
      {
        "name": "RoadmapMutationErrorExtension"
      },
      {
        "name": "ShepherdGenericMutationErrorExtension"
      },
      {
        "name": "ToolchainAssociateEntitiesErrorExtension"
      },
      {
        "name": "ToolchainCreateContainerErrorExtension"
      },
      {
        "name": "ToolchainDisassociateEntitiesErrorExtension"
      },
      {
        "name": "TownsquareCreateGoalHasJiraAlignProjectMutationErrorExtension"
      },
      {
        "name": "TownsquareCreateRelationshipsMutationErrorExtension"
      },
      {
        "name": "TownsquareDeleteGoalHasJiraAlignProjectMutationErrorExtension"
      },
      {
        "name": "TownsquareDeleteRelationshipsMutationErrorExtension"
      },
      {
        "name": "TownsquareProjectsChildWorkItemsAlreadyLinkedMutationErrorExtension"
      },
      {
        "name": "TownsquareProjectsCreateLinkMutationErrorExtension"
      },
      {
        "name": "TownsquareProjectsEditMutationErrorExtension"
      },
      {
        "name": "TownsquareProjectsParentWorkItemAlreadyLinkedToAnotherProjectMutationErrorExtension"
      },
      {
        "name": "TownsquareProjectsWorkItemAlreadyLinkedMutationErrorExtension"
      },
      {
        "name": "TrelloMutationErrorExtension"
      },
      {
        "name": "UpdateExCoSpacePermissionsMutationErrorExtension"
      },
      {
        "name": "VirtualAgentValidationMutationErrorExtension"
      },
      {
        "name": "WorkSuggestionsMutationErrorExtension"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "Payload",
    "possibleTypes": [
      {
        "name": "ActivatePaywallContentPayload"
      },
      {
        "name": "AddPublicLinkPermissionsPayload"
      },
      {
        "name": "ArchiveSpacePayload"
      },
      {
        "name": "BulkDeleteContentDataClassificationLevelPayload"
      },
      {
        "name": "BulkRemoveRoleAssignmentFromSpacesPayload"
      },
      {
        "name": "BulkSetRoleAssignmentToSpacesPayload"
      },
      {
        "name": "BulkSetSpacePermissionAsyncPayload"
      },
      {
        "name": "BulkSetSpacePermissionPayload"
      },
      {
        "name": "BulkUpdateContentDataClassificationLevelPayload"
      },
      {
        "name": "ConfluenceAcceptAnswerPayload"
      },
      {
        "name": "ConfluenceAddCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceChangeOrderOfCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceConvertContentToBlogpostPayload"
      },
      {
        "name": "ConfluenceCopyPageHierarchyPayload"
      },
      {
        "name": "ConfluenceCopySpaceSecurityConfigurationPayload"
      },
      {
        "name": "ConfluenceCreateAnswerPayload"
      },
      {
        "name": "ConfluenceCreateBlogPostPayload"
      },
      {
        "name": "ConfluenceCreateBlogPostPropertyPayload"
      },
      {
        "name": "ConfluenceCreateCustomRolePayload"
      },
      {
        "name": "ConfluenceCreateFooterCommentOnBlogPostPayload"
      },
      {
        "name": "ConfluenceCreateFooterCommentOnPagePayload"
      },
      {
        "name": "ConfluenceCreatePagePayload"
      },
      {
        "name": "ConfluenceCreatePagePropertyPayload"
      },
      {
        "name": "ConfluenceCreatePdfExportTaskForBulkContentPayload"
      },
      {
        "name": "ConfluenceCreatePdfExportTaskForSingleContentPayload"
      },
      {
        "name": "ConfluenceCreateQuestionPayload"
      },
      {
        "name": "ConfluenceCreateSpacePayload"
      },
      {
        "name": "ConfluenceCreateTopicPayload"
      },
      {
        "name": "ConfluenceDeleteAnswerPayload"
      },
      {
        "name": "ConfluenceDeleteBlogPostPropertyPayload"
      },
      {
        "name": "ConfluenceDeleteCalendarCustomEventTypePayload"
      },
      {
        "name": "ConfluenceDeleteCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceDeleteCustomRolePayload"
      },
      {
        "name": "ConfluenceDeleteDraftBlogPostPayload"
      },
      {
        "name": "ConfluenceDeleteDraftPagePayload"
      },
      {
        "name": "ConfluenceDeleteGlobalPageTemplatePayload"
      },
      {
        "name": "ConfluenceDeletePagePropertyPayload"
      },
      {
        "name": "ConfluenceDeleteQuestionPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarAllFutureEventsPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarEventPayload"
      },
      {
        "name": "ConfluenceDeleteSubCalendarSingleEventPayload"
      },
      {
        "name": "ConfluenceDeleteTopicPayload"
      },
      {
        "name": "ConfluenceDisableBlueprintPayload"
      },
      {
        "name": "ConfluenceDisableDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceDisableGlobalPageBlueprintPayload"
      },
      {
        "name": "ConfluenceEnableBlueprintPayload"
      },
      {
        "name": "ConfluenceEnableDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceEnableGlobalPageBlueprintPayload"
      },
      {
        "name": "ConfluenceImportSpacePayload"
      },
      {
        "name": "ConfluenceMarkAllCommentsAsReadPayload"
      },
      {
        "name": "ConfluencePatchFolderPayload"
      },
      {
        "name": "ConfluencePromoteBlueprintPayload"
      },
      {
        "name": "ConfluencePromotePageTemplatePayload"
      },
      {
        "name": "ConfluencePublishBlogPostPayload"
      },
      {
        "name": "ConfluencePublishPagePayload"
      },
      {
        "name": "ConfluencePurgeBlogPostPayload"
      },
      {
        "name": "ConfluencePurgePagePayload"
      },
      {
        "name": "ConfluenceReactedUsersResponsePayload"
      },
      {
        "name": "ConfluenceReactionPayload"
      },
      {
        "name": "ConfluenceReopenCommentPayload"
      },
      {
        "name": "ConfluenceRepairJiraMacroAppLinksPayload"
      },
      {
        "name": "ConfluenceRequestSpaceAccessPayload"
      },
      {
        "name": "ConfluenceResetDefaultSpaceLogoPayload"
      },
      {
        "name": "ConfluenceResetJiraMacroAppLinksScanStatusPayload"
      },
      {
        "name": "ConfluenceResolveCommentByContentIdPayload"
      },
      {
        "name": "ConfluenceResolveCommentsPayload"
      },
      {
        "name": "ConfluenceSaveOrUpdateSpaceOwnerPayload"
      },
      {
        "name": "ConfluenceScanJiraMacroAppLinksPayload"
      },
      {
        "name": "ConfluenceTrashBlogPostPayload"
      },
      {
        "name": "ConfluenceTrashPagePayload"
      },
      {
        "name": "ConfluenceUnpromoteBlueprintPayload"
      },
      {
        "name": "ConfluenceUnpromotePageTemplatePayload"
      },
      {
        "name": "ConfluenceUpdateAnswerPayload"
      },
      {
        "name": "ConfluenceUpdateCurrentBlogPostPayload"
      },
      {
        "name": "ConfluenceUpdateCurrentPagePayload"
      },
      {
        "name": "ConfluenceUpdateCustomApplicationLinkPayload"
      },
      {
        "name": "ConfluenceUpdateCustomContentPermissionsPayload"
      },
      {
        "name": "ConfluenceUpdateCustomPageConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateCustomRolePayload"
      },
      {
        "name": "ConfluenceUpdateDraftBlogPostPayload"
      },
      {
        "name": "ConfluenceUpdateDraftPagePayload"
      },
      {
        "name": "ConfluenceUpdateEmailSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalDefaultLocaleConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalPageTemplateDescriptionPayload"
      },
      {
        "name": "ConfluenceUpdateGlobalThemePayload"
      },
      {
        "name": "ConfluenceUpdateIndexingLanguageConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateLoomEntryPointsConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateNav4OptInPayload"
      },
      {
        "name": "ConfluenceUpdateNewCodeMacroPayload"
      },
      {
        "name": "ConfluenceUpdatePdfExportConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateQuestionPayload"
      },
      {
        "name": "ConfluenceUpdateSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSiteSecurityConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSiteSenderEmailAddressPayload"
      },
      {
        "name": "ConfluenceUpdateSlackSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateSpacePayload"
      },
      {
        "name": "ConfluenceUpdateSpaceSettingsPayload"
      },
      {
        "name": "ConfluenceUpdateSpaceThemePayload"
      },
      {
        "name": "ConfluenceUpdateSubCalendarHiddenEventsPayload"
      },
      {
        "name": "ConfluenceUpdateTeamAdminControlsSettingsPayload"
      },
      {
        "name": "ConfluenceUpdateTeamPresenceSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateTeamsSiteConfigurationPayload"
      },
      {
        "name": "ConfluenceUpdateTopicPayload"
      },
      {
        "name": "ConfluenceUpdateValueBlogPostPropertyPayload"
      },
      {
        "name": "ConfluenceUpdateValuePagePropertyPayload"
      },
      {
        "name": "ConfluenceUpdateVotePayload"
      },
      {
        "name": "ConfluenceUploadDefaultSpaceLogoPayload"
      },
      {
        "name": "ConvertPageToLiveEditActionPayload"
      },
      {
        "name": "CreateContentMentionNotificationActionPayload"
      },
      {
        "name": "CreateFaviconFilesPayload"
      },
      {
        "name": "CreateInlineTaskNotificationPayload"
      },
      {
        "name": "CreateMentionReminderNotificationPayload"
      },
      {
        "name": "DeactivatePaywallContentPayload"
      },
      {
        "name": "DeleteDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "DeleteExCoSpacePermissionsPayload"
      },
      {
        "name": "DeleteExternalCollaboratorDefaultSpacePayload"
      },
      {
        "name": "DeleteSpaceDefaultClassificationLevelPayload"
      },
      {
        "name": "DeleteSpaceRoleAssignmentsPayload"
      },
      {
        "name": "EditorDraftSyncPayload"
      },
      {
        "name": "FavouriteSpaceBulkPayload"
      },
      {
        "name": "InvokeAuxEffectsResponse"
      },
      {
        "name": "InvokeExtensionResponse"
      },
      {
        "name": "NotificationResponsePayload"
      },
      {
        "name": "RecoverSpaceAdminPermissionPayload"
      },
      {
        "name": "RecoverSpaceWithAdminRoleAssignmentPayload"
      },
      {
        "name": "RemovePublicLinkPermissionsPayload"
      },
      {
        "name": "ResetToDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "ResolveRestrictionsPayload"
      },
      {
        "name": "RestoreSpacePayload"
      },
      {
        "name": "SetDefaultSpaceRoleAssignmentsPayload"
      },
      {
        "name": "SetSpaceRoleAssignmentsPayload"
      },
      {
        "name": "SoftDeleteSpacePayload"
      },
      {
        "name": "UnarchiveSpacePayload"
      },
      {
        "name": "UpdateCoverPictureWidthPayload"
      },
      {
        "name": "UpdateDefaultSpacePermissionsPayloadV2"
      },
      {
        "name": "UpdateExCoSpacePermissionsPayload"
      },
      {
        "name": "UpdateExternalCollaboratorDefaultSpacePayload"
      },
      {
        "name": "UpdateNestedPageOwnersPayload"
      },
      {
        "name": "UpdatePageOwnersPayload"
      },
      {
        "name": "UpdatePageStatusesPayload"
      },
      {
        "name": "UpdateSiteLookAndFeelPayload"
      },
      {
        "name": "UpdateSpaceDefaultClassificationLevelPayload"
      },
      {
        "name": "UpdateSpaceDetailsPayload"
      },
      {
        "name": "UpdateSpacePermissionsPayloadV2"
      },
      {
        "name": "UpdateSpaceTypeSettingsPayload"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "ContentPlatformOrganizationAndAuthorUnion",
    "possibleTypes": [
      {
        "name": "ContentPlatformAuthor"
      },
      {
        "name": "ContentPlatformOrganization"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "ConfluenceCustomContentPermissionPrincipal",
    "possibleTypes": [
      {
        "name": "ConfluenceCustomContentPermissionAccessClassPrincipal"
      },
      {
        "name": "ConfluenceCustomContentPermissionAppPrincipal"
      },
      {
        "name": "ConfluenceCustomContentPermissionGroupPrincipal"
      },
      {
        "name": "ConfluenceCustomContentPermissionGuestPrincipal"
      },
      {
        "name": "ConfluenceCustomContentPermissionUserPrincipal"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SmartFeaturesResultResponse",
    "possibleTypes": [
      {
        "name": "SmartFeaturesPageResultResponse"
      },
      {
        "name": "SmartFeaturesSpaceResultResponse"
      },
      {
        "name": "SmartFeaturesUserResultResponse"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "FeedEvent",
    "possibleTypes": [
      {
        "name": "FeedEventComment"
      },
      {
        "name": "FeedEventCreate"
      },
      {
        "name": "FeedEventEdit"
      },
      {
        "name": "FeedEventEditLive"
      },
      {
        "name": "FeedEventPublishLive"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "PageActivityEvent",
    "possibleTypes": [
      {
        "name": "PageActivityEventCreatedComment"
      },
      {
        "name": "PageActivityEventCreatedPage"
      },
      {
        "name": "PageActivityEventPublishedPage"
      },
      {
        "name": "PageActivityEventSnapshottedPage"
      },
      {
        "name": "PageActivityEventStartedPage"
      },
      {
        "name": "PageActivityEventUpdatedPage"
      }
    ]
  },
  {
    "kind": "UNION",
    "name": "MediaAttachmentOrError",
    "possibleTypes": [
      {
        "name": "MediaAttachment"
      },
      {
        "name": "MediaAttachmentError"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "LocalizationContext",
    "possibleTypes": [
      {
        "name": "AtlassianAccountUser"
      },
      {
        "name": "CustomerUser"
      },
      {
        "name": "ThirdPartyUser"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SearchL2FeatureProvider",
    "possibleTypes": [
      {
        "name": "SearchConfluencePageBlogAttachment"
      },
      {
        "name": "SearchConfluenceSpace"
      },
      {
        "name": "SearchResultGoogleDocument"
      },
      {
        "name": "SearchResultGooglePresentation"
      },
      {
        "name": "SearchResultGoogleSpreadsheet"
      },
      {
        "name": "SearchResultGraphDocument"
      },
      {
        "name": "SearchResultMicrosoftDocument"
      },
      {
        "name": "SearchResultSlackMessage"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "AssetsObjectNode",
    "possibleTypes": [
      {
        "name": "AssetsObject"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "RadarEntity",
    "possibleTypes": [
      {
        "name": "RadarPosition"
      },
      {
        "name": "RadarWorker"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "KnowledgeDiscoveryEntity",
    "possibleTypes": [
      {
        "name": "KnowledgeDiscoveryConfluenceBlogpost"
      },
      {
        "name": "KnowledgeDiscoveryConfluencePage"
      },
      {
        "name": "KnowledgeDiscoveryConfluenceSpace"
      },
      {
        "name": "KnowledgeDiscoveryJiraProject"
      },
      {
        "name": "KnowledgeDiscoveryTopic"
      },
      {
        "name": "KnowledgeDiscoveryUser"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraHasMultipleSelectedValues",
    "possibleTypes": [
      {
        "name": "JiraAffectedServicesField"
      },
      {
        "name": "JiraConnectMultipleSelectField"
      },
      {
        "name": "JiraMultipleSelectField"
      },
      {
        "name": "JiraMultipleVersionPickerField"
      },
      {
        "name": "JiraServiceManagementOrganizationField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraTimelineVirtualField",
    "possibleTypes": [
      {
        "name": "JiraAggregatedTimelineField"
      },
      {
        "name": "JiraTimelineField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraHasSingleSelectedValue",
    "possibleTypes": [
      {
        "name": "JiraConnectSingleSelectField"
      },
      {
        "name": "JiraSingleSelectField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "AdminErrorExtension",
    "possibleTypes": [
      {
        "name": "AdminApplicationErrorExtension"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "SecurityWorkspace",
    "possibleTypes": [
      {
        "name": "ThirdPartySecurityWorkspace"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraAppNavigationConfig",
    "possibleTypes": [
      {
        "name": "JiraAppNavigationItem"
      },
      {
        "name": "JiraAppNavigationItemNestedLink"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraFieldSetsViewMetadata",
    "possibleTypes": [
      {
        "name": "JiraFieldSetView"
      },
      {
        "name": "JiraTimelineView"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraSpreadsheetView",
    "possibleTypes": [
      {
        "name": "JiraGroupedListView"
      },
      {
        "name": "JiraListView"
      },
      {
        "name": "JiraTimelineView"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraServiceManagementRequestTypeFieldCommon",
    "possibleTypes": [
      {
        "name": "JiraServiceManagementAttachmentPreviewField"
      },
      {
        "name": "JiraServiceManagementDatePreviewField"
      },
      {
        "name": "JiraServiceManagementDateTimePreviewField"
      },
      {
        "name": "JiraServiceManagementDueDatePreviewField"
      },
      {
        "name": "JiraServiceManagementMultiCheckboxesPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiSelectPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiServicePickerPreviewField"
      },
      {
        "name": "JiraServiceManagementMultiUserPickerPreviewField"
      },
      {
        "name": "JiraServiceManagementPeoplePreviewField"
      },
      {
        "name": "JiraServiceManagementSelectPreviewField"
      },
      {
        "name": "JiraServiceManagementTextAreaPreviewField"
      },
      {
        "name": "JiraServiceManagementTextPreviewField"
      },
      {
        "name": "JiraServiceManagementUnknownPreviewField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "JiraJourneyItemCommon",
    "possibleTypes": [
      {
        "name": "JiraJourneyStatusDependency"
      },
      {
        "name": "JiraJourneyWorkItem"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TrelloBaseBoardPrefs",
    "possibleTypes": [
      {
        "name": "TrelloBoardPrefs"
      },
      {
        "name": "TrelloInboxPrefs"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TrelloBaseBoard",
    "possibleTypes": [
      {
        "name": "TrelloBoard"
      },
      {
        "name": "TrelloInbox"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TrelloProviderCalendarInterface",
    "possibleTypes": [
      {
        "name": "TrelloPlannerCalendar"
      },
      {
        "name": "TrelloPlannerProviderCalendar"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TownsquareCustomFieldNode",
    "possibleTypes": [
      {
        "name": "TownsquareNumberCustomField"
      },
      {
        "name": "TownsquareTextCustomField"
      },
      {
        "name": "TownsquareTextSelectCustomField"
      },
      {
        "name": "TownsquareUserCustomField"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TownsquareCustomFieldSavedValueNode",
    "possibleTypes": [
      {
        "name": "TownsquareCustomFieldNumberSavedValueNode"
      },
      {
        "name": "TownsquareCustomFieldTextSavedValueNode"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CompassCustomFieldScorecardCriteria",
    "possibleTypes": [
      {
        "name": "CompassHasCustomBooleanFieldScorecardCriteria"
      },
      {
        "name": "CompassHasCustomMultiSelectFieldScorecardCriteria"
      },
      {
        "name": "CompassHasCustomNumberFieldScorecardCriteria"
      },
      {
        "name": "CompassHasCustomSingleSelectFieldScorecardCriteria"
      },
      {
        "name": "CompassHasCustomTextFieldScorecardCriteria"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "CompassWorkItemEdge",
    "possibleTypes": [
      {
        "name": "CompassComponentScorecardWorkItemEdge"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TrelloAction",
    "possibleTypes": [
      {
        "name": "TrelloAddAttachmentToCardAction"
      },
      {
        "name": "TrelloAddChecklistToCardAction"
      },
      {
        "name": "TrelloAddMemberToCardAction"
      },
      {
        "name": "TrelloCommentCardAction"
      },
      {
        "name": "TrelloCopyCardAction"
      },
      {
        "name": "TrelloCopyCommentCardAction"
      },
      {
        "name": "TrelloCopyInboxCardAction"
      },
      {
        "name": "TrelloCreateCardAction"
      },
      {
        "name": "TrelloCreateCardFromCheckItemAction"
      },
      {
        "name": "TrelloCreateCardFromEmailAction"
      },
      {
        "name": "TrelloCreateInboxCardAction"
      },
      {
        "name": "TrelloDeleteAttachmentFromCardAction"
      },
      {
        "name": "TrelloMoveCardAction"
      },
      {
        "name": "TrelloMoveCardToBoardAction"
      },
      {
        "name": "TrelloMoveInboxCardToBoardAction"
      },
      {
        "name": "TrelloRemoveChecklistFromCardAction"
      },
      {
        "name": "TrelloRemoveMemberFromCardAction"
      },
      {
        "name": "TrelloUpdateCardClosedAction"
      },
      {
        "name": "TrelloUpdateCardCompleteAction"
      },
      {
        "name": "TrelloUpdateCardDueAction"
      },
      {
        "name": "TrelloUpdateCardRecurrenceRuleAction"
      },
      {
        "name": "TrelloUpdateCheckItemStateOnCardAction"
      },
      {
        "name": "TrelloUpdateCustomFieldItemAction"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TrelloCardActionData",
    "possibleTypes": [
      {
        "name": "TrelloAddAttachmentToCardAction"
      },
      {
        "name": "TrelloAddChecklistToCardAction"
      },
      {
        "name": "TrelloAddMemberToCardAction"
      },
      {
        "name": "TrelloCommentCardAction"
      },
      {
        "name": "TrelloCopyCardAction"
      },
      {
        "name": "TrelloCopyCommentCardAction"
      },
      {
        "name": "TrelloCopyInboxCardAction"
      },
      {
        "name": "TrelloCreateCardAction"
      },
      {
        "name": "TrelloCreateCardFromCheckItemAction"
      },
      {
        "name": "TrelloCreateCardFromEmailAction"
      },
      {
        "name": "TrelloCreateInboxCardAction"
      },
      {
        "name": "TrelloDeleteAttachmentFromCardAction"
      },
      {
        "name": "TrelloMoveCardAction"
      },
      {
        "name": "TrelloMoveCardToBoardAction"
      },
      {
        "name": "TrelloMoveInboxCardToBoardAction"
      },
      {
        "name": "TrelloRemoveChecklistFromCardAction"
      },
      {
        "name": "TrelloRemoveMemberFromCardAction"
      },
      {
        "name": "TrelloUpdateCardClosedAction"
      },
      {
        "name": "TrelloUpdateCardCompleteAction"
      },
      {
        "name": "TrelloUpdateCardDueAction"
      },
      {
        "name": "TrelloUpdateCardRecurrenceRuleAction"
      },
      {
        "name": "TrelloUpdateCheckItemStateOnCardAction"
      },
      {
        "name": "TrelloUpdateCustomFieldItemAction"
      }
    ]
  },
  {
    "kind": "INTERFACE",
    "name": "TownsquareCustomFieldDefinitionNode",
    "possibleTypes": [
      {
        "name": "TownsquareNumberCustomFieldDefinition"
      },
      {
        "name": "TownsquareTextCustomFieldDefinition"
      },
      {
        "name": "TownsquareTextSelectCustomFieldDefinition"
      },
      {
        "name": "TownsquareUserCustomFieldDefinition"
      }
    ]
  }
]
